'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fakeStorage = require('fake-storage');

var _fakeStorage2 = _interopRequireDefault(_fakeStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sessionStorage = void 0;
try {
  sessionStorage = window.sessionStorage;
} catch (e) {
  sessionStorage = new _fakeStorage2.default();
}

exports.default = sessionStorage;
module.exports = exports['default'];
//# sourceMappingURL=SessionStorage.js.map